import React from 'react';
import clsx from 'clsx';

import styles from './SelectableCard.module.scss';

interface SelectableCardProps {
  title: string;
  onClick: () => void;
  subtitle?: string;
  disabled?: boolean;
  isLoading?: boolean;
  selected?: boolean;
  withRadio?: boolean;
}

const SelectableCard = ({
  title,
  subtitle,
  onClick,
  disabled,
  isLoading,
  selected = false,
  withRadio = true,
}: SelectableCardProps) => (
  <div
    className={clsx(
      styles.selectableCard,
      selected && styles.cardSelected,
      disabled && !isLoading && styles.disabled,
      isLoading && styles.loading,
    )}
    onClick={disabled ? undefined : onClick}
  >
    <div className={styles.content}>
      <p>{title}</p>
      {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
    </div>

    {withRadio && <div className={clsx(styles.radio, selected && styles.radioSelected, disabled && styles.disabled)} />}
  </div>
);

export default SelectableCard;
